import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const courses = [
  {
    title: '美容マーケティング基礎講座',
    desc: 'SNSを活用した美容ビジネスのマーケティング基礎を学ぶ入門コース。初めての方でも安心して受講できます。',
    duration: '全6回（各90分）',
    level: '初級',
    format: 'オンライン',
    price: '¥48,000',
    img: 'https://readdy.ai/api/search-image?query=elegant%20beauty%20marketing%20course%20online%20learning%20desk%20with%20cosmetics%20flowers%20soft%20light%20minimal%20clean%20white%20background&width=500&height=320&seq=c1&orientation=landscape',
    topics: ['SNSマーケティング基礎', 'コンテンツ制作入門', 'ターゲット設定', '効果測定の基本'],
  },
  {
    title: 'ブランディング戦略セミナー',
    desc: '美容ブランドの価値を高めるブランディング戦略を実践的に学ぶ1日集中セミナー。',
    duration: '1日集中（6時間）',
    level: '中級',
    format: 'オンライン / 対面',
    price: '¥28,000',
    img: 'https://readdy.ai/api/search-image?query=beauty%20branding%20strategy%20seminar%20workshop%20elegant%20feminine%20soft%20pastel%20background%20cosmetics%20professional&width=500&height=320&seq=c2&orientation=landscape',
    topics: ['ブランドアイデンティティ', 'ビジュアルブランディング', 'ストーリーテリング', '競合差別化'],
  },
  {
    title: 'SNS運用マスター講座',
    desc: 'Instagram・TikTokを使った美容コンテンツ制作と集客を徹底解説する実践講座。',
    duration: '全8回（各60分）',
    level: '初〜中級',
    format: 'オンライン',
    price: '¥58,000',
    img: 'https://readdy.ai/api/search-image?query=social%20media%20content%20creation%20beauty%20influencer%20elegant%20phone%20camera%20soft%20light%20pastel%20minimal%20professional&width=500&height=320&seq=c3&orientation=landscape',
    topics: ['Instagram運用術', 'TikTok活用法', 'リール・ショート動画制作', 'フォロワー獲得戦略'],
  },
  {
    title: '美容ビジネス英語講座',
    desc: '海外展開や外国人顧客対応に必要な美容業界特化の英語コミュニケーション講座。',
    duration: '全10回（各60分）',
    level: '初〜中級',
    format: 'オンライン',
    price: '¥68,000',
    img: 'https://readdy.ai/api/search-image?query=beauty%20business%20english%20learning%20elegant%20woman%20desk%20minimal%20clean%20white%20flowers%20pastel%20professional%20feminine&width=500&height=320&seq=c4&orientation=landscape',
    topics: ['美容用語英語', 'カウンセリング英語', 'SNS英語投稿', 'ビジネスメール英語'],
  },
  {
    title: 'コンサルティング実践ワークショップ',
    desc: '実際のケーススタディを使って、美容ビジネスのコンサルティングスキルを磨くワークショップ。',
    duration: '全4回（各120分）',
    level: '上級',
    format: '対面',
    price: '¥88,000',
    img: 'https://readdy.ai/api/search-image?query=beauty%20consulting%20workshop%20group%20elegant%20professional%20women%20meeting%20minimal%20clean%20white%20office%20light%20blue&width=500&height=320&seq=c5&orientation=landscape',
    topics: ['課題分析手法', '提案書作成', 'プレゼンテーション', 'フィードバック実践'],
  },
  {
    title: '美容トレンド情報セミナー',
    desc: '最新の美容トレンドと市場動向を解説する定期開催セミナー。業界の最前線情報をお届けします。',
    duration: '月1回（90分）',
    level: '全レベル',
    format: 'オンライン',
    price: '¥5,000 / 回',
    img: 'https://readdy.ai/api/search-image?query=beauty%20trend%20seminar%20elegant%20presentation%20minimal%20clean%20white%20light%20blue%20flowers%20cosmetics%20professional%20feminine&width=500&height=320&seq=c6&orientation=landscape',
    topics: ['国内外トレンド', '新製品情報', '市場データ解説', 'Q&Aセッション'],
  },
];

export default function CoursesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-32 pb-16 bg-gradient-to-br from-white via-sky-50 to-white overflow-hidden">
        <div className="absolute top-0 right-0 w-72 h-72 opacity-20 pointer-events-none">
          <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 100 C60 60, 10 80, 20 110 C30 140, 80 120, 100 100Z" fill="#BAE6FD" />
            <path d="M100 100 C140 60, 190 80, 180 110 C170 140, 120 120, 100 100Z" fill="#7DD3FC" />
            <ellipse cx="100" cy="100" rx="14" ry="12" fill="#38BDF8" />
          </svg>
        </div>
        <div className="max-w-6xl mx-auto px-6 text-center">
          <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Courses &amp; Seminars</span>
          <h1 className="text-3xl md:text-4xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            講座・セミナー
          </h1>
          <p className="text-slate-500 text-sm mt-4 max-w-md mx-auto">
            美容ビジネスに必要な知識とスキルを、実践的なプログラムで学べます。
          </p>
        </div>
      </div>

      {/* Courses Grid */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {courses.map((c) => (
              <div key={c.title} className="bg-white border border-sky-50 rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300">
                <div className="relative h-48 overflow-hidden">
                  <img src={c.img} alt={c.title} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-sky-400/10"></div>
                </div>
                <div className="p-6">
                  <div className="flex flex-wrap items-center gap-2 mb-3">
                    <span className="text-xs text-sky-400 border border-sky-200 px-2 py-0.5 rounded-full">{c.level}</span>
                    <span className="text-xs text-slate-400 border border-slate-200 px-2 py-0.5 rounded-full">{c.format}</span>
                  </div>
                  <h3 className="text-base font-semibold text-slate-800 mb-2">{c.title}</h3>
                  <p className="text-slate-500 text-xs leading-relaxed mb-4">{c.desc}</p>
                  <div className="space-y-1 mb-4">
                    {c.topics.map((t) => (
                      <div key={t} className="flex items-center gap-2 text-xs text-slate-500">
                        <i className="ri-check-line text-sky-300 flex-shrink-0"></i>
                        {t}
                      </div>
                    ))}
                  </div>
                  <div className="flex items-center justify-between pt-4 border-t border-sky-50">
                    <div>
                      <p className="text-xs text-slate-400">{c.duration}</p>
                      <p className="text-base font-semibold text-sky-400 mt-0.5">{c.price}</p>
                    </div>
                    <Link
                      to="/contact"
                      className="px-4 py-2 rounded-full bg-sky-50 text-sky-400 text-xs font-medium hover:bg-sky-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      お申し込み
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-sky-50">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-light text-slate-800 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ご不明な点はお気軽にご相談ください
          </h2>
          <p className="text-slate-500 text-sm mb-8">講座の詳細や受講方法についてのご質問もお待ちしています。</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-sky-300 text-white text-sm font-medium hover:bg-sky-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            お問い合わせ
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
